fx.ns("shared.popups", class RemoveAddImpossiblePopup extends shared.popups.BasePersonPopup{
    
    constructor(book, action)
    {
        super(book, fx.get("assets").personAdvice);
        this.contentWidth = 500;
        this.contentHeight = 200;

        this.book = book;
        this.action = action;
    }

    get photo()
    {
        return this.data;
    }


 
    create()
    {
        super.create();

        let title;
        let message;
 
        if (this.action == "adding")
        {
            title = fx.text("Ajout impossible");
            message = fx.text("Votre album photo ne peut contenir plus de $ pages.", this.book.maxPages);
        }
        else
        {
            title = fx.text("Suppression impossible");
            message = fx.text("Votre album photo ne peut contenir moins de $ pages.", this.book.minPages);
        }
            
        this.addChild(new fx.components.Text({text:title, className:"title center"}));
        this.addChild(new fx.components.Text({text:message, className:"text center"}));

        this.addFooterChild("close");
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.close, this.okButton);
    }


});